import {
  Button,
  Container,
  Flex,
  Group,
  Space,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import { Trans, useTranslation } from "react-i18next";
import classes from "./HeroContent.module.css";
import parse from "html-react-parser";
import I18n from "../../i18n.js";
import {
  IconBrandDiscord,
  IconCpu,
  IconRouteSquare,
} from "@tabler/icons-react";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";
import { useCart } from '../Cart/CartContext';
import { DEBUG } from "../..";

export function HeroContent() {
  const { openCart } = useCart();
  const navigate = useNavigate();
  const redirectToCart = () => {
    if(DEBUG) console.log("Fire openCart()")
    navigate("/cart");
  };
  const { t } = useTranslation("translations");

  return (
    <Container size="md" className={classes.mainContainer}>
      <div className={classes.content}>
        <Title className={classes.title}>
          <Text
            fs="italic"
            inherit
            variant="gradient"
            gradient={{ from: "#99180D", to: "#D3423D" }}
          >
            <Trans i18nKey="title.toolkit" />
          </Text>
          <Text component="span" inherit>
            <Trans i18nKey="title.creator" />
          </Text>
        </Title>
        <Text className={classes.description} mt={30}>
          <Trans i18nKey="title.advertisement-text" />
        </Text>
        <Space h={"xl"}/>
        <Group>
          <Link to={"features"}>
            <Button
              variant="default"
              size="lg"
              
              className={classes.control}
            >
              Features
            </Button>
          </Link>
          <Link to={"community"}>
            <Button
              variant="default"
              size="lg"
              
              className={classes.control}
            >
              Community
            </Button>
          </Link>

          <Button
            variant="gradient"
            gradient={{ from: "#D3423D", to: "#99180D" }}
            size="lg"
            className={classes.control}
            
            onClick={openCart}
          >
            <Trans i18nKey="title.download-buy" />
          </Button>
        </Group>
      </div>

      <Group>
        <Flex
          mih={50}
          maw={150}
          gap="md"
          justify="flex-start"
          align="flex-start"
          direction="column"
          wrap="wrap"
        >
          <ThemeIcon size="xl" variant="default">
            <IconBrandDiscord color={"#B23028"} />
          </ThemeIcon>
          <Text>{parse(I18n.t('title.community'))}</Text>
        </Flex>
        <Flex
          mih={50}
          maw={150}
          gap="md"
          justify="flex-start"
          align="flex-start"
          direction="column"
          wrap="wrap"
        >
          <ThemeIcon size="xl" variant="default">
            <IconCpu color={"#B23028"} />
          </ThemeIcon>
          <Trans i18nKey="title.performance" />
        </Flex>
        <Flex
          mih={50}
          maw={150}
          gap="md"
          justify="flex-start"
          align="flex-start"
          direction="column"
          wrap="wrap"
        >
          <ThemeIcon size="xl" variant="default">
            <IconRouteSquare color={"#B23028"} />
          </ThemeIcon>
          <Trans i18nKey="title.updates" />
        </Flex>
      </Group>
    </Container>
  );
}
